import styled from 'styled-components'

export default styled.img`
  height: 30px;
  margin-right: 10px;
  width: 30px;
`
